import { appTypeId } from '../../../models/application-types';

export class Controller {

    /** @ngInject */
    constructor($state, AddNewApplicationResource) {
        this.state = $state;
        this.AddNewApplicationResource = AddNewApplicationResource;
    }

    addCustomApplication() {
        this.appType$(appTypeId('custom')).get()
            .then(appType => this.AddNewApplicationResource
                .createSecureApp(this.companyId, appType.id)
                .then(app => this.state.go('company.manage-application.integration-developers.integration', {appId: app.id})))
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/custom-application-integration/custom-application-integration.controller.js